export var AgentDealType;
(function (AgentDealType) {
    AgentDealType["Any"] = "any";
    AgentDealType["Rent"] = "rent";
    AgentDealType["Sale"] = "sale";
})(AgentDealType || (AgentDealType = {}));
